export type MetricVisibilityKey = 'flakeScore' | 'mttf';

export const hiddenMetricColumns = new Set<MetricVisibilityKey>(['flakeScore', 'mttf']);
export const hiddenMetricDeltaColumns = new Set<MetricVisibilityKey>(['flakeScore', 'mttf']);

export const isMetricVisible = (key: MetricVisibilityKey): boolean => {
  return !hiddenMetricColumns.has(key);
};

export const isMetricDeltaVisible = (key: MetricVisibilityKey): boolean => {
  return !hiddenMetricDeltaColumns.has(key);
};
